import { render, staticRenderFns } from "./ClaimApprovalInfo.vue?vue&type=template&id=c3386cf6"
import script from "./ClaimApprovalInfo.vue?vue&type=script&lang=js"
export * from "./ClaimApprovalInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports